const appConfig = {
  enableDirectPlayback:
    (process.env.REACT_APP_ENABLE_DIRECT_PLAYBACK ?? "false") === "true",
};

export default appConfig;
